// @flow
import DenzelError from 'app/common/lib/DenzelError';

type ResourceResponseType = {
  data: any,
  error: ?DenzelError,
};

type Bookmark = string | '-end-';

/**
 * The response from a resource call.
 */
export class ResourceResponse {
  resource_response: ResourceResponseType;
  client_context: ?Object;
  moduleTree: null;
  page_info: ?Object;
  request_identifier: string;
  bookmarks: [Bookmark];
  originHost: ?string;

  constructor() {
    this.resource_response = {
      data: null,
      error: null,
    };

    this.client_context = null;
    this.moduleTree = null;
    this.page_info = null;
    this.request_identifier = '';
  }
}

const resourceResponse = {
  /**
   * Deserialize the JSON response body of a resource request.
   */
  fromPlainObject(plainData: Object): ResourceResponse {
    const resourceRsp = new ResourceResponse();

    resourceRsp.client_context = plainData.client_context;
    resourceRsp.page_info = plainData.page_info;
    resourceRsp.request_identifier = plainData.request_identifier;

    const _resource: ?Object = plainData.resource;
    if (_resource && _resource.options) {
      resourceRsp.bookmarks = _resource.options.bookmarks || ['-end-'];
    }
    const responseData: ?Object = plainData.resource_response.data;
    resourceRsp.resource_response.data = responseData;

    const errorPlainObject: ?Object = plainData.resource_response.error;
    resourceRsp.resource_response.error = errorPlainObject
      ? DenzelError.fromPlainObject(errorPlainObject, responseData)
      : null;

    return resourceRsp;
  },
};

export default resourceResponse;
